import Icon20 from 'components/common/Icon20'

export default Icon20
